import {
    Column
} from 'devextreme-react/data-grid';

import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { useGetAssignedCFIs } from '../api/get-assigned-cfis';
import { useAuth } from '../../../../contexts/auth';

export default function AssignedCFIsGrid() {

    const { user } = useAuth();
    const cfis = useGetAssignedCFIs(user?.companyId!);

    return (
        <>
            <SyncDataGrid
                stateStorageKey='assigned-cfis-grid'
                className={'dx-card wide-card'}
                dataSource={cfis.data}
                keyExpr={'cfiDealerAssignmentID'}
            >
                <Column
                    dataField={'productLine'}
                    caption={'Product Line'}
                    dataType="string"
                />
                <Column
                    dataField={'subProductLine'}
                    caption={'Sub Product Line'}
                    dataType="string"
                />
                <Column
                    dataField={'companyName'}
                    caption={'Provider Name'}
                    dataType="string"
                />
                <Column
                    dataField={'phone'}
                    caption={'Phone Number'}
                    dataType="string"
                />
                <Column
                    dataField={'address'}
                    caption={'Address'}
                    dataType="string"
                />
            </SyncDataGrid>

            <LoadPagePanel visible={cfis.isLoading} />
        </>
    )
} 
